module.exports = __webpack_public_path__ + "src/img/reporter.b603ddcf.svg";